import DashboardCards from "./Components/DashboardCards";
// import AllContacts from "./Components/AllContacts";

export default function Dashboard() {
  return (
    <>
      <DashboardCards />
      {/* <AllContacts /> */}
    </>
  );
}
